<canvas #imageCanvas width="500" height="500">
</canvas>
<div *ngIf="image">
    <p><small>Width: {{ image.bitmap.width }}, Height: {{  image.bitmap.height }}</small></p>
    <p *ngIf="image.bitmap.width > 32 || image.bitmap.height > 32"><small>This image is too large to be displayed on the device. Please crop and select.</small></p>
</div>